import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import ModuleLandingPage from "../../../Components/ModuleLandingPage";
import SortableTable from "../../../Components/SortableTable";
import { getNavigationRoutes } from "../../../Config/routes";
import { getToken, requestErrorHandler } from "../../../Utils/Common";
import EnvSettings from "../../../Utils/EnvSettings";

const server = EnvSettings.server;

export default function EmailLists(props) {
  const history = useHistory();
  const { t } = useTranslation();
  const [emaillists, setLists] = useState();
  const [search, setSearch] = useState("");
  const searchTerms = search.trim().toLowerCase().split(/\s+/).filter(Boolean);
  const filteredLists =
    emaillists &&
    emaillists.filter((list) => {
      const name = (list.name || "").toLowerCase();
      return searchTerms.every((term) => name.includes(term));
    });
  const dispatch = useDispatch();
  let getEmailLists = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token: getToken() }),
    };
    fetch(server + "/get_email_lists", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          setLists(result.emaillist);
        }
      });
  };

  let showUser = (id) => {
    history.push("/cpanel/emaillists/" + id.id);
  };

  const handleScrollClick = (event, id) => {
    if (window.location.href.includes("/cpanel/")) {
      window.open("/cpanel/emaillists/" + id.id, "_blank");
    }
  };

  useEffect(getEmailLists, []);

  const navigationLinks = getNavigationRoutes("emailLists").map((route) => ({
    href: route.path,
    title: t(route.title),
    icon: route.icon,
  }));

  return (
    <ModuleLandingPage
      title={t("emailLists.header")}
      navigation={navigationLinks}
      filters={
        <Grid item xs={12}>
          <TextField
            id="email-lists-search"
            label={t("emailLists.search")}
            variant="outlined"
            fullWidth
            value={search}
            onChange={(event) => setSearch(event.target.value)}
          />
        </Grid>
      }
    >
      {emaillists ? (
        <SortableTable
          key={search}
          headCells={[
            {
              id: "name",
              numeric: false,
              disablePadding: false,
              label: t("emailLists.name"),
            },
            {
              id: "EmailListUsers",
              numeric: false,
              disablePadding: false,
              label: t("emailLists.numberOfSubs"),
            },
          ]}
          defaultSortRow={"name"}
          handleRowClick={showUser}
          handleScrollClick={handleScrollClick}
          specialDataFormatting={[
            {
              id: "EmailListUsers",
              format: (data) => {
                if (!data) {
                  return "";
                }
                return data.length;
              },
            },
          ]}
          tableData={filteredLists}
          rowsPerPage={25}
        />
      ) : undefined}
      {emaillists && filteredLists.length === 0
        ? t("emailLists.noResults")
        : null}
    </ModuleLandingPage>
  );
}
